<template>
  <li
    ref="accordion"
    class="list-group-item"
    :class="{ 'is-done': isEventDone }"
  >
    <div class="list-collapse">
      <div class="list-collapse-header">
        <div class="list-group-text">
          <p class="text-primary text-bold text-xs space-b-half">
            <span class="mr-2">
              {{ event.date | formatDateWeekDay }}
            </span>
            <span>
              {{ event.start_time | formatTime }}
            </span>
          </p>
          <p v-html="event.title" />
        </div>
        <div
          class="list-collapse-trigger"
          :class="{ 'is-active': isOpen }"
          @click="toggleDetail"
        >
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>

      <div
        class="list-collapse-body list-group-detail"
        :style="{ height: accordionHeight }"
      >
        <div class="list-group-detail-item">
          <p class="text-bold">ご参加人数</p>
          <p class="text-paragraph">{{ event.reserve_count }}人</p>
        </div>
        <div class="list-group-detail-item" v-if="hasShowParticipant">
          <p class="text-bold">ご参加される方々</p>
          <ul>
            <li v-if="event.reserve_groom">新郎様</li>
            <li v-if="event.reserve_groom_father">新郎家お父様</li>
            <li v-if="event.reserve_groom_mother">新郎家お母様</li>
            <li v-if="event.reserve_bride">新婦様</li>
            <li v-if="event.reserve_bride_father">新婦家お父様</li>
            <li v-if="event.reserve_bride_mother">新婦家お母様</li>
          </ul>
        </div>
        <div class="list-group-detail-item" v-if="hasShowAllergy">
          <p class="text-bold">参加者に食材アレルギーがある方</p>
          <p class="text-paragraph">{{ this.event.has_allergy ? '有' : '無' }}</p>
        </div>
        <div class="list-group-detail-item" v-if="hasMemo">
          <p class="text-bold">備考</p>
          <p class="text-paragraph" v-html="$options.filters.breakLine(event.customer_memo)" />
        </div>
        <div class="list-group-detail-item space-t-4">
          <p class="text-light text-xs text-center" v-if="isEventDone">
            このイベントは終了いたしました
          </p>
          <p class="text-light text-xs text-center" v-else-if="isEventClosed">
            このご予約はWEBからのキャンセルができません。<br />
            担当者までお問い合わせください。
          </p>
          <div class="list-group-detail-action" v-else-if="isEventAccepting"> 
            <WaveButton type="button" @click="onCancel">
              キャンセルする
            </WaveButton>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { formatDateWeekDay } from '@/filters/format-date'
import formatTime from '@/filters/format-time'
import { breakLine } from '@/utils/dom'

const REASERVATION_STATUS_ACCEPTIONG = 1
const REASERVATION_STATUS_CLOSED = 2
const REASERVATION_STATUS_DONE = 3
const EVENT_TYPE_FOODS = 4

export default {
  props: {
    event: {
      type: Object,
      required: true,
    }
  },

  filters: {
    formatDateWeekDay,
    formatTime,
    breakLine,
  },
  
  data() {
    return {
      isOpen: false,
      isLoading: false,
      accordionHeight: ''
    }
  },

  computed: {
    isEventAccepting() {
      return this.event.reservation_status === REASERVATION_STATUS_ACCEPTIONG
    },
    isEventClosed() {
      return this.event.reservation_status === REASERVATION_STATUS_CLOSED
    },
    isEventDone() {
      return this.event.reservation_status === REASERVATION_STATUS_DONE
    },
    hasShowParticipant() {
      return this.event.type === EVENT_TYPE_FOODS
    },
    hasShowAllergy() {
      return this.event.allergy_confirmation && this.event.has_allergy !== null
    },
    hasMemo() {
      return this.event.customer_memo !== ''
    }
  },

  methods: {
    onCancel() {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      this.$emit('cancel', this.event.event_id, this.clearLoad)
    },
    clearLoad() {
      this.isLoading = false
    },
    toggleDetail() {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.slideDown()
      } else {
        this.slideUp()
      }
    },
    slideDown() {
      const targetMaxHeight = this.$refs.accordion.children[0].clientHeight
      let targetHeight = 0
      const heightPerTime = targetMaxHeight / 50
      const slideDown = () => {
        const slideDownTimer = setInterval(() => {
          targetHeight += heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight >= targetMaxHeight) {
            clearInterval(slideDownTimer)
            this.accordionHeight = 'auto'
          }
        }, 5)
      }
      slideDown()
    },
    slideUp() {
      let targetHeight = this.$refs.accordion.children[0].clientHeight
      const heightPerTime = targetHeight / 50
      const slideUp = () => {
        const slideUpTimer = setInterval(() => {
          targetHeight -= heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight <= 0) {
            clearInterval(slideUpTimer)
            this.accordionHeight = 0
          }
        }, 5)
      }
      slideUp()
    },
  }
}
</script>
